<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>港口名称：</p>
        <el-input
          v-model="entrustIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入港口名称" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>作业类型：</p>
        <el-select
          v-model="typeIpt"
          size="mini"
          filterable
          style="width: 150px"
          placeholder="请选择作业类型">
          <el-option label="全部" value="" />
          <el-option label="装车" value="1" />
          <el-option label="卸车" value="2" />
          <el-option label="过驳" value="3" />
          <el-option label="转船" value="4" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>适配车型：</p>
        <el-input
          v-model="customerCarName"
          size="mini"
          style="width: 150px"
          placeholder="请输入适配车型" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>状态：</p>
        <el-select
          v-model="stateIpt"
          size="mini"
          filterable
          style="width: 150px"
          placeholder="请选择状态">
          <el-option
            v-for="item in stateOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>结算方式：</p>
        <el-select
          v-model="contractTypeIpt"
          size="mini"
          filterable
          style="width: 150px"
          placeholder="请选择结算方式">
          <el-option
            v-for="item in contractTypeOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>录入人员：</p>
        <el-input v-model="createByName" size="mini" style="width: 150px" placeholder="请输入录入人员" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" type="primary" @click="batchEnable">启用</el-button>
        <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
        <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div class="tableContainerNav">
          <span @click="downLoad" style="cursor: pointer">下载模板</span>
          <span style="cursor: pointer">
            <el-upload
              ref="upload"
              class="upload-demo"
              :action="uploadUrl"
              :auto-upload="true"
              :show-file-list="false"
              :data="uploadData"
              :on-success="planOnSuccess"
              :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right" style="margin-left: 13px">批量导入</i>
            </el-upload>
          </span>
          <span class="ml10 pointer" @click="exportData">导出数据</span>
        </div>
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
          }"
          @selection-change="selectionChange"
          :row-style="rowStyle" >
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column prop="portName" label="港口名称" align="center" />
          <el-table-column prop="contractCode" label="合同编号" align="center" />
          <el-table-column label="作业类型" align="center">
            <div slot-scope="scope">{{ getWorkType(scope.row.workType) }}</div>
          </el-table-column>
          <el-table-column
            prop="customerCarName"
            label="适配车型"
            show-overflow-tooltip
            align="center" />
          <el-table-column prop="taxRate" label="税率%" align="center" />
          <el-table-column
            prop="createTime"
            label="创建时间"
            show-overflow-tooltip
            width="150"
            align="center">
            <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
          </el-table-column>
          <el-table-column
            prop="createByName"
            label="录入人员"
            show-overflow-tooltip
            width="150"
            align="center" />
          <el-table-column prop="startDate" label="有效起始" align="center" />
          <el-table-column prop="endDate" label="结束时间" align="center" />
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="操作" width="360" align="center">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; padding-left: 10px">
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row.id)"
                  >详情
                </el-button>
                <el-button
                  v-if="!scope.row.status || scope.row.status === 1"
                  size="mini"
                  :loading="scope.row.changeLoad"
                  class="yellow-bg"
                  type="primary"
                  @click="changeClick(scope.row, scope.row.status)">
                  {{ !scope.row.status ? '修改' : '修改车型' }}
                </el-button>
                <el-button
                  v-if="!scope.row.status"
                  size="mini"
                  type="primary"
                  @click="enableClick(scope.row)"
                  >启用
                </el-button>
                <el-button
                  v-if="scope.row.status === 1"
                  size="mini"
                  type="danger"
                  @click="disableClick(scope.row)"
                  >停用
                </el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)"
                  >删除
                </el-button>
<!--                <el-button size="mini" class="yellow-bg" @click="recordBtn(scope.row)">补录合同</el-button>-->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="600px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">港口名称：</span>
              <span>{{ detailData.portName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">作业类型：</span>
              <span>{{ getWorkType(detailData.workType) }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">合同名称：</span>
              <span>{{ detailData.contractName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">合同编号：</span>
              <span>{{ detailData.contractCode }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">适配车型：</span>
              <span>{{ detailData.customerCarName }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">有效期始：</span>
                <span>{{ detailData.startDate }}</span>
              </div>
              <div>
                <span class="span1">结束时间：</span>
                <span>{{ detailData.endDate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>价格设置</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">税率：</span>
              <span>{{ detailData.taxRate }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">预估价：</span>
              <span>{{ detailData.estimatePrice }}</span>
            </div>
            <div class="baseInfoContentItem" v-if="detailData.contractType == 0">
              <span class="span1">预结算价：</span>
              <span>{{ detailData.preparePrice }}</span>
            </div>
            <div class="baseInfoContentItem" v-if="detailData.contractType == -1">
              <span class="span1">结算价：</span>
              <span>无</span>
            </div>
            <div class="baseInfoContentItem specialItem" v-if="detailData.contractType == 1">
              <div class="specialOne">
                <span class="span1">合同方式：</span>
                <span>{{ getContract(detailData.contractType) }}</span>
              </div>
              <div>
                <span class="span1">合同价格：</span>
                <span>{{ detailData.contractFixed }}</span>
              </div>
            </div>
            <div
              class="baseInfoContentItem"
              v-if="detailData.contractType == 2 || detailData.contractType == 3">
              <span class="span1">合同方式：</span>
              <span>{{ getContract(detailData.contractType) }}</span>
            </div>
            <div
              class="baseInfoContentItem"
              v-if="detailData.contractType == 2 || detailData.contractType == 3">
              <div>
                <el-table :data="detailData.ladderList" border>
                  <el-table-column label="序号" align="center" type="index" />
                  <el-table-column prop="startNum" label="起始数量" align="center" />
                  <el-table-column prop="endNum" label="结束数量" align="center" />
                  <el-table-column prop="contractPrice" label="合同价" align="center" />
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>补录合同</span>
          </div>
          <div class="operationTable">
            <el-table
              :data="contractTableList"
              border
              :header-cell-style="{
                background: '#E8E8E8',
                color: '#3B3B3B',
                height: '35px',
              }">
              <el-table-column
                type="index"
                label="序号"
                width="50"
                align="center"></el-table-column>
              <el-table-column
                property="codeNumber"
                label="合同编号"
                min-width="150"
                align="center" />
              <el-table-column
                property="contractName"
                label="合同名称"
                min-width="150"
                align="center" />
              <el-table-column
                property="typeName"
                label="合同类型"
                min-width="100"
                align="center" />
              <el-table-column
                prop="supplementaryContract.rate"
                label="税率"
                min-width="150"
                align="center" />
              <el-table-column
                prop="supplementaryContract.taxContractPrice"
                label="含税合同价"
                min-width="150"
                align="center" />
              <el-table-column
                prop="supplementaryContract.contractPrice"
                label="不含税合同价"
                min-width="150"
                align="center" />
              <el-table-column
                property="startDate"
                label="开始日期"
                min-width="100"
                :formatter="getDate"
                align="center" />
              <el-table-column
                property="endDate"
                label="结束日期"
                min-width="100"
                :formatter="getDate"
                align="center" />
              <el-table-column width="200px" label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="deleteTableClick(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>适配车型</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.carModelList" border>
              <el-table-column type="index" label="序号" align="center" />
              <el-table-column prop="brandName" label="品牌" align="center" />
              <el-table-column prop="modelName" label="型号" align="center" />
              <el-table-column label="状态" align="center" width="160px">
                <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.operateRecordList" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">
                  {{ getTime(scope.row.createTime) }}
                </div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      center
      @close="dialogClose"
      :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="companyData" label-width="100px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" divStyle="margin-top: 10px;">
            <el-row>
              <el-col v-if="editType === 0">
                <el-form-item
                  label="港口名称："
                  style="margin-top: 10px; margin-bottom: 0px"
                  prop="name">
                  <el-select
                    v-model="companyData.name"
                    value-key="id"
                    @change="nameChange"
                    :disabled="dialogTitle == '修改港口价格'"
                    filterable
                    size="small"
                    style="width: 100%"
                    placeholder="请选择港口">
                    <el-option
                      v-for="item in nameOption"
                      :key="item.id"
                      :label="item.supplier_name"
                      :value="item" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="editType === 0">
                <el-form-item label="作业类型：" style="margin-top: 10px" prop="type">
                  <el-select
                    v-model="companyData.type"
                    :disabled="dialogTitle == '修改港口价格'"
                    filterable
                    size="small"
                    style="width: 100%"
                    placeholder="请选择作业类型"
                    value-key="id">
                    <el-option label="装车" :value="1" />
                    <el-option label="卸车" :value="2" />
                    <el-option label="过驳" :value="3" />
                    <el-option label="转船" :value="4" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :class="{ mt10: editType === 1 }">
                <el-form-item
                  label="适配车型："
                  style="margin-bottom: 0"
                  class="model-item"
                  prop="model">
                  <!-- <span style="margin-right: 5px;" v-for="(item,index) in selectedCar">{{item.name}}<span v-if="index!==selectedCar.length-1">、</span></span>
                  <span style="color: rgba(51, 136, 255, 1);cursor: pointer;" @click="carClick">点击选择车辆</span> -->
                  <cascader
                    ref="cascader"
                    :options="modelOption"
                    :props="{
                      value: 'id',
                      label: 'model',
                      children: 'carModel',
                      multiple: true,
                    }"
                    :filed="'model'"
                    @getValue="getValue" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="editType === 0">
                <el-form-item label="有效期始：" prop="start" style="margin-bottom: 20px">
                  <el-date-picker
                    v-model="companyData.start"
                    size="small"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效开始时间" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="editType === 0">
                <el-form-item label="结束日期：" prop="end">
                  <el-date-picker
                    v-model="companyData.end"
                    size="small"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效结束时间"
                    default-time="23:59:59"/>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="合同设置" divStyle="margin-top: 10px">
            <el-row>
              <el-col :span='24'>
                <el-form-item label='合同：' prop='contractId'>
                  <el-select v-model="companyData.contractId" filterable style="width: 100%" size="small"
                             placeholder="请选择合同" value-key="id"  :disabled="dialogTitle == '修改港口价格'">
                    <el-option
                      v-for="item in contractOption" :key="item.id" :label="item.name"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
<!--            <el-row>-->
<!--              <el-col :span="24">-->
<!--                <el-form-item label="合同设置：">-->
<!--                  <el-row>-->
<!--                    <el-col :span="12">-->
<!--                      <span class="set-up" @click="contractBtn">设置</span>-->
<!--                    </el-col>-->
<!--                  </el-row>-->
<!--                  <el-row v-if="companyData.companyName || companyData.codeNumber">-->
<!--                    <el-col :span="24">-->
<!--                      <span class="item-span">合同名称：{{ companyData.companyName }}</span>-->
<!--                    </el-col>-->
<!--                    <el-col :span="15">-->
<!--                      <span class="item-span">合同编号：{{ companyData.codeNumber }}</span>-->
<!--                    </el-col>-->
<!--                  </el-row>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
          </div-border>
          <div-border label="基础信息" divStyle="margin-top: 10px" v-if="editType === 0">
            <el-row>
              <el-col>
                <el-form-item label="税率：" prop="rate" style="margin-top: 10px">
                  <el-input
                    type="number"
                    :style="'width:100%'"
                    v-model="companyData.rate"
                    placeholder="请输入税率"
                    autocomplete="off"
                    size="small">
                    <span slot="suffix" style="color: #999">| %</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="预估价：" prop="price">
                  <el-input
                    type="number"
                    :style="'width:100%'"
                    v-model="companyData.price"
                    placeholder="请输入预估价"
                    autocomplete="off"
                    size="small">
                    <span slot="suffix" style="color: #999">| 元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col>
                <el-form-item label="结算价设置：">
                  <el-row>
                    <el-col :span="12">
                      <span class="item-span">
                        {{(companyData.priceType==1||companyData.priceType==3)?'合同价':(companyData.priceType==2?'预结算价':'未设置')}}
                        </span>
                    </el-col>
                    <el-col :span="12">
                      <span v-if="companyData.priceType==3" class="item-span">阶梯价</span>
                      <span v-else class="item-span">{{companyData.priceType&&companyData.priceType!=0?'价格：'+companyData.price:''}}</span>
                      <span class="set-up" @click="priceSetBtn">设置</span>
                    </el-col>
                  </el-row>
                  <el-row v-if="companyData.companyName||companyData.codeNumber">
                    <el-col :span="12">
                      <span class="item-span">合同名称：{{companyData.companyName}}</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="item-span">合同编号：{{companyData.codeNumber}}</span>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col> -->
              <el-col>
                <el-form-item label="结算方式：" prop="way">
                  <el-radio size="mini" v-model="companyData.way" :label="0">无</el-radio>
                  <el-radio size="mini" v-model="companyData.way" :label="1">合同价</el-radio>
                  <el-radio size="mini" v-model="companyData.way" :label="2">预结算价</el-radio>
                </el-form-item>
              </el-col>
              <el-col v-if="companyData.way == 2" :span="24">
                <el-form-item label="预结算价：" prop="price2">
                  <el-input
                    type="number"
                    :style="'width:100%'"
                    v-model="companyData.price2"
                    placeholder="请输入预结算价"
                    autocomplete="off"
                    size="small">
                    <span slot="suffix" style="color: #999">| 元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col v-if="companyData.way==2" :span="24">
                <div style="display: flex;align-items: center;">
                  <el-form-item label="预结算方式：" prop="method">
                    <el-radio size="mini" v-model="companyData.method" :label="1">固定</el-radio>
                    <el-radio size="mini" v-model="companyData.method" :label="2">比例</el-radio>
                  </el-form-item>
                  <el-form-item prop="method2" class="specialItem">
                    <el-input
                      style="width:150px;margin-left: 10px;"
                      v-model="companyData.method2"
                      placeholder="请输入预估价"
                      autocomplete="off"
                      size="mini"
                    >
                      <span slot="suffix" style="color: #999">|  {{ companyData.method===2?'%':'元' }}</span>
                    </el-input>
                  </el-form-item>
                </div>
              </el-col> -->
              <el-col v-if="companyData.way == 1 && companyData.type != 4">
                <el-form-item label="合同价方式：" propprice3="contract">
                  <el-radio size="mini" v-model="companyData.contract" :label="1">固定</el-radio>
                  <el-radio size="mini" v-model="companyData.contract" :label="2">阶梯</el-radio>
                  <el-radio size="mini" v-model="companyData.contract" :label="3"
                    >阶梯后返回</el-radio
                  >
                </el-form-item>
              </el-col>
              <el-col
                v-if="
                  (companyData.contract === 1 && companyData.way == 1) ||
                  (companyData.type == 4 && companyData.way == 1)
                ">
                <el-form-item label="固定合同价：" prop="price3" style="margin-bottom: 17px">
                  <el-input
                    style="width: 150px"
                    v-model="companyData.price3"
                    placeholder="请输入固定合同价"
                    autocomplete="off"
                    size="small">
                    <span slot="suffix" style="color: #999">| 元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col
                v-if="
                  companyData.way == 1 &&
                  (companyData.contract === 2 || companyData.contract === 3) &&
                  companyData.type != 4
                ">
                <el-form-item label="阶梯合同价：" prop="table">
                  <el-table border :data="companyData.table">
                    <el-table-column label="序号" align="center" type="index" />
                    <el-table-column prop="startNum" label="起始数量" align="center" />
                    <el-table-column label="结束数量" align="center">
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model="companyData.table[scope.$index].endNum"
                          size="mini"
                          style="width: 100%"
                          placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="合同价" align="center">
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model="companyData.table[scope.$index].contractPrice"
                          size="mini"
                          style="width: 100%"
                          placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <div
                        slot-scope="scope"
                        style="display: flex; align-items: center; justify-content: center">
                        <img
                          v-if="
                            scope.$index !== 0 &&
                            Number(companyData.table[scope.$index].startNum) <
                              Number(companyData.table[scope.$index - 1].endNum)
                          "
                          alt=""
                          :src="require('@/assets/images/u725.png')"
                          :style="'width:22px;height:22px;cursor: pointer;'"
                          @click="removeClick(scope.$index)" />
                        <img
                          v-else-if="scope.$index + 1 === companyData.table.length"
                          alt=""
                          :src="require('@/assets/images/add.png')"
                          :style="'width:22px;height:22px;cursor: pointer;'"
                          @click="addImgClick" />
                        <span v-else>-</span>
                      </div>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="btnLoad" @click="addClick"
              >确定
            </el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="选择适配车型"
      :visible.sync="carVisible"
      width="600px"
      @close="carClose"
      center
      :close-on-click-modal="false"
      top="20vh">
      <div class="carContainer">
        <div class="carContainerTitle">
          <span>已选择车型：</span>
          <div class="carContainerTitleContent">
            <div
              class="carContainerTitleContentItem"
              v-for="item in selectCar"
              @click="selectRemove(item)">
              {{ item.name }}<i class="el-icon-close" />
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择品牌：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectBrand">
              <p @click="brandClick(item.id)">{{ item.name }}&nbsp;</p>
              <i class="el-icon-plus" @click="brandAdd(item)" />
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择型号：</span>
          <div class="carContainerTitleContent">
            <div
              class="carContainerTitleContentItem"
              v-for="item in selectModel"
              @click="modelAdd(item)">
              <p>{{ item.name }}</p>
              <i class="el-icon-plus" />
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="mini" @click="carAddClick">确定</el-button>
          <el-button class="resetBtn" size="mini" @click="carClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 结算价格设置 -->
    <el-dialog
      title="结算价格设置"
      :visible.sync="priceSetVisible"
      class="price-window"
      :close-on-click-modal="false"
      append-to-body
      width="910px">
      <div-border label="价格设置">
        <el-form :model="priceSetForm" label-width="100px">
          <el-form-item label="结算方式：" style="margin-top: 15px; margin-bottom: 5px">
            <span style="display: inline-block; width: 300px">
              <el-radio-group v-model="priceSetForm.type" @change="typeChange">
                <el-radio :label="1">合同价格</el-radio>
                <el-radio :label="2">预结算价格</el-radio>
              </el-radio-group>
            </span>
            <span
              style="
                display: inline-block;
                width: calc(100% - 300px);
                text-align: right;
                padding-right: 15px;
              ">
              <el-input
                size="small"
                v-if="priceSetForm.type == 2"
                v-model="priceSetForm.price"
                placeholder="请输入价格"
                style="width: calc(100% - 150px); margin-right: 10px" />
              <el-button size="small" class="searchBtn" @click="priceSetConfirm">确定</el-button>
              <el-button size="small" class="resetBtn" @click="priceSetVisible = false"
                >取消</el-button
              >
            </span>
          </el-form-item>
          <el-form-item label="结算单价：" v-if="priceSetForm.type == 1" style="margin-bottom: 5px">
            <el-radio-group
              v-model="priceSetForm.conType"
              style="display: inline-block; width: 220px">
              <el-radio :label="0">固定价格</el-radio>
              <el-radio :label="1">阶梯价格</el-radio>
            </el-radio-group>
            <el-input
              v-if="priceSetForm.conType == 0"
              size="small"
              v-model="priceSetForm.price"
              placeholder="请输入价格"
              style="width: calc(100% - 400px); margin-right: 10px" />
            <span v-if="priceSetForm.conType == 1" class="price-set" @click="ladderShow">设置</span>
          </el-form-item>
        </el-form>
      </div-border>
      <div-border
        :is-need="true"
        v-if="priceSetForm.type != 0"
        label="选择合同"
        style="padding: 29px 20px">
        <div class="nav">
          <div class="navContainer">
            <p>合同编号：</p>
            <el-input
              v-model="condition.codeNumber"
              size="mini"
              style="width: 150px"
              placeholder="请输入合同编号" />
          </div>
          <div class="navContainer">
            <p>合同名称：</p>
            <el-input
              v-model="condition.contractName"
              size="mini"
              style="width: 150px"
              placeholder="请输入合同名称" />
          </div>
          <div class="navContainer">
            <p>签约单位：</p>
            <el-input
              v-model="condition.companyName"
              size="mini"
              style="width: 150px"
              placeholder="请输入签约单位" />
          </div>
          <div class="navBtn">
            <el-button size="small" class="searchBtn" @click="_contractPageList">查询</el-button>
            <el-button size="small" class="resetBtn" @click="resetBtn1">重置</el-button>
          </div>
        </div>
        <el-table
          :data="contractData"
          highlight-current-row
          border
          ref="contractTable"
          @current-change="contractChange"
          v-loading="contractLoad"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-weight': '700',
            padding: '0px',
            'font-size': '13px',
            height: '35px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
          <el-table-column type="index" width="50" />
          <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
          <el-table-column
            property="contractName"
            label="合同名称"
            min-width="150"
            align="center" />
          <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
          <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
          <el-table-column
            property="startDate"
            label="开始日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
          <el-table-column
            property="endDate"
            label="结束日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
        </el-table>
        <div style="margin-top: 20px">
          <el-pagination
            background
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
            @size-change="contractSizeChange1"
            @current-change="contractCurrentChange1"
            :current-page.sync="page1"
            :page-size="rows1" />
        </div>
      </div-border>
    </el-dialog>
    <!-- 阶梯 -->
    <el-dialog
      title="新增水路价格"
      :visible.sync="dialogShow"
      width="723px"
      @close="waterPriceAddClose"
      center
      :append-to-body="true"
      :close-on-click-modal="false">
      <div style="width: 100%; padding: 30px" class="water" v-if="dialogShow">
        <div-border label="价格设置" style="padding: 20px">
          <el-form :model="waterPriceData" ref="addForm" class="demo-ruleForm" :rules="waterRules">
            <el-table
              :data="waterPriceData.DataTable"
              style="width: 100%"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                'font-size': '13px',
                height: '35px',
                background: '#E8E8E8',
              }"
              :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
              <el-table-column
                type="index"
                width="50"
                align="center"
                label="序号"></el-table-column>
              <el-table-column label="起始数量" prop="startNum" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0px"
                    :prop="`DataTable[${scope.$index}].startNum`"
                    :rules="waterRules.startNum">
                    <el-input
                      size="mini"
                      v-model="scope.row.startNum"
                      placeholder="请输入起始数量"
                      disabled>
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="结束数量" prop="endNum" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0px"
                    :prop="`DataTable[${scope.$index}].endNum`"
                    :rules="waterRules.endNum">
                    <el-input
                      size="mini"
                      :disabled="scope.$index + 1 != waterPriceData.DataTable.length"
                      v-model="scope.row.endNum"
                      placeholder="请输入结束数量"
                      @change="waterPriceDataEndNumberChange(scope.$index, scope.row.endNum)">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="合同价" prop="contractPrice" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0px"
                    :prop="`DataTable[${scope.$index}].contractPrice`"
                    :rules="waterRules.contractPrice">
                    <el-input
                      size="mini"
                      v-model="scope.row.contractPrice"
                      placeholder="请输入合同价">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="50">
                <i
                  class="el-icon-error"
                  style="font-size: 20px; cursor: pointer"
                  slot-scope="scope"
                  @click="waterPriceDeleteTable(scope.$index)"
                  v-if="
                    waterPriceData.DataTable.length > 1 &&
                    scope.$index + 1 == waterPriceData.DataTable.length
                  "></i>
                <span v-else>--</span>
              </el-table-column>
              <div slot="append" style="padding: 9px">
                <el-button
                  size="medium"
                  type="warning"
                  icon="el-icon-plus"
                  circle
                  style="padding: 4px"
                  @click="waterPriceAdd" />
                <span style="margin: 10px">添加</span>
              </div>
            </el-table>
          </el-form>
        </div-border>
        <div style="display: flex; flex-direction: row; justify-content: center">
          <el-button size="mini" class="searchBtn" @click="waterPriceConfirm">确认</el-button>
          <el-button size="mini" class="resetBtn" @click="waterPriceAddClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  补录合同  -->
    <el-dialog
      title="补录合同"
      :visible.sync="contractVisible"
      :close-on-click-modal="false"
      append-to-body
      width="910px"
      @close="cancel">
      <div-border label="价格设置">
        <div class="nav" style="margin-top: 10px">
          <div class="navContainer" style="width: 300px">
            <p style="width: 100px">不含税金额：</p>
            <el-input
              v-model.number="condition.price"
              size="mini"
              style="width: 150px"
              placeholder="请输入不含税金额" />
          </div>
          <div class="navContainer">
            <p>含税金额：</p>
            <el-input
              v-model.number="condition.taxPrice"
              size="mini"
              style="width: 150px"
              placeholder="请输入含税金额" />
          </div>
          <div class="navBtn" style="width: 200px; margin: -30px 555px 15px">
            <el-button size="small" class="searchBtn" @click="_contractConfirm">确定</el-button>
            <el-button size="small" class="resetBtn" @click="cancel">取消</el-button>
          </div>
        </div>
      </div-border>
      <div-border label="选择合同">
        <el-table
          :data="contractTableData"
          highlight-current-row
          border
          ref="contractTable"
          @current-change="contractChange"
          v-loading="contractLoad"
          style="margin-top: 10px"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-weight': '700',
            padding: '0px',
            'font-size': '13px',
            height: '35px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
          <el-table-column type="index" width="50" />
          <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
          <el-table-column
            property="contractName"
            label="合同名称"
            min-width="150"
            align="center" />
          <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
          <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
          <el-table-column
            property="startDate"
            label="开始日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
          <el-table-column
            property="endDate"
            label="结束日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
        </el-table>
        <div style="margin-top: 20px">
          <el-pagination
            background
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="contractTotal"
            @size-change="addContractSizeChange"
            @current-change="addContractCurrentChange"
            :current-page.sync="page"
            :page-size="row" />
        </div>
      </div-border>
    </el-dialog>
    <!-- 添加合同 -->
    <el-dialog
      :title="dialogContratTitle"
      :visible.sync="addVisible"
      :close-on-click-modal="false"
      append-to-body
      width="910px">
      <div class="navContract">
        <div class="navContainer">
          <p>合同编号：</p>
          <el-input
            v-model="addData.codeNumber"
            size="mini"
            style="width: 150px"
            placeholder="请输入合同编号" />
        </div>
        <div class="navContainer">
          <p>合同名称：</p>
          <el-input
            v-model="addData.contractName"
            size="mini"
            style="width: 150px"
            placeholder="请输入合同名称" />
        </div>
        <div class="navContainer">
          <p>签约单位：</p>
          <el-input
            v-model="addData.companyName"
            size="mini"
            style="width: 150px"
            placeholder="请输入签约单位" />
        </div>
        <div class="navBtn">
          <el-button size="small" class="searchBtn" @click="contractPageList">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetContractBtn = false"
          >重置</el-button
          >
          <el-button size="small" class="searchBtn" @click="contractConfirm">确定</el-button>
        </div>
      </div>
      <el-table
        :data="contractData"
        highlight-current-row
        border
        ref="contractTable"
        @current-change="contractChange"
        v-loading="contractLoad"
        :header-cell-style="{
          color: '#3B3B3B',
          'font-weight': '700',
          padding: '0px',
          'font-size': '13px',
          height: '35px',
          background: '#E8E8E8',
        }"
        :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
        <el-table-column type="index" width="50" />
        <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
        <el-table-column property="contractName" label="合同名称" min-width="150" align="center" />
        <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
        <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
        <el-table-column
          property="startDate"
          label="开始日期"
          min-width="100"
          :formatter="getDate"
          align="center" />
        <el-table-column
          property="endDate"
          label="结束日期"
          min-width="100"
          :formatter="getDate"
          align="center" />
      </el-table>
      <div style="margin-top: 20px">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChangeAll"
          @current-change="contractCurrentChangeOne"
          :current-page.sync="page"
          :page-size="rows" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import steps from '@/components/steps';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import cascader from '@/components/cascader';
  import { getImport, getImportUrl } from '@/service/getIP';
  import {
    getCarSerieList,
    portConfigureDetail,
    revisePortConfigure,
    deletePortConfigure,
    getTypeInfo,
    portConfigureInforList,
    addPortConfigureInfo,
    contractPageList,
    enablePortConfigure,
    deleteContractInfo,
    getContractPageList,
    addContract,
    getContractInfo,
  } from '@/service/financial';
  import { supplierPublicSelectPort } from '@/service/vehiclelog';
  import { baseUrl } from '@/config/env';

  export default {
    components: {
      steps,
      divBorder,
      cascader,
    },
    data() {
      return {
        importLoading: false,
        uploadUrl: '', //导入地址
        uploadData: {
          file: '',
        },
        entrustIpt: '',
        typeIpt: '',
        customerCarName: '',
        stateIpt: '',
        contractTypeIpt: '',
        createByName: '',
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待生效',
          },
          {
            value: 1,
            label: '生效中',
          },
          {
            value: 2,
            label: '已失效',
          },
        ],
        contractTypeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '预结算',
          },
          {
            value: '1',
            label: '固定合同',
          },
          {
            value: '2',
            label: '阶梯合同',
          },
          {
            value: '3',
            label: '阶梯后返还合同',
          },
          {
            value: '-1',
            label: '无结算价',
          },
        ],
        contractVisible: false,
        contractTableData: [],
        condition: {
          price: '',
          taxPrice: '',
          priceInfoId: '',
          rate: '',
        },
        //总数据条数
        total: 0,
        //当前页数
        page: 1,
        //每页显示多少条数据
        row: 10,
        size: 10,
        contractTotal: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        contractTableList: [],
        dialogVisible: false,
        dialogTitle: '',
        nameOption: [],
        payOption: [],
        modelOption: [],
        modelMap: new Map(),
        brandMap: new Map(),
        addressOption: [],
        companyData: {
          priceType: 1,
          // 新增/修改弹窗页面数据
          name: {
            id: '',
            name: '',
            supplier_id: ''
          },
          contractId:'',
          companyId: '', // 合同id
          companyName: '', // 合同名称
          codeNumber: '', // 合同编号
          },
        contractOption: [],
        rules: {
          name: [
            {
              required: true,
              message: '请选择港口',
              trigger: 'change',
            },
          ],
          contractId: [
            {
              required: true,
              message: '请选择合同',
              trigger: 'change',
            },
          ],
          start: [
            {
              required: true,
              message: '请选择有效开始时间',
              trigger: 'change',
            },
          ],
          end: [
            {
              required: true,
              message: '请选择有效结束时间',
              trigger: 'change',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择作业类型',
              trigger: 'change',
            },
          ],
          rate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'blur',
            },
          ],
          // price:[
          //   { required: true, message: '请输入预估价', trigger: 'blur' },
          // ],
          // way:[
          //   { required: true, message: '请选择结算方式', trigger: 'blur' },
          // ],
          price2: [
            {
              required: true,
              message: '请输入预结算价',
              trigger: 'blur',
            },
          ],
          method: [
            {
              required: true,
              message: '请选择预结算方式',
              trigger: 'change',
            },
          ],
          method2: [
            {
              required: true,
              message: '请输入预估价',
              trigger: 'blur',
            },
          ],
          contract: [
            {
              required: true,
              message: '请输入合同价方式',
              trigger: 'blur',
            },
          ],
          // price3:[
          //   { required: true, message: '请输入固定合同价', trigger: 'blur' },
          // ],
          model: [
            {
              required: true,
              message: '请选择适配类型',
              trigger: 'blur',
            },
          ],
          table: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
        },
        carVisible: false,
        selectedCar: [],
        selectCar: [],
        brands: [],
        models: [],
        brands2: [],
        models2: [],
        selectBrand: [],
        selectModel: [],
        allCar: [],
        allModel: [],
        btnLoad: false, // 新增/修改 确认按钮状态
        changeLoad: false, //修改按钮状态

        // 结算价格设置弹窗 数据
        priceSetForm: {
          type: 0,
          price: '',
        },
        priceSetVisible: false,
        // 合同编号弹窗 数据
        // condition: {
        //   codeNumber: '',
        //   contractName: '',
        //   companyName: '',
        // },
        //总数据条数
        total1: 0,
        //当前页数
        page1: 1,
        //每页显示多少条数据
        rows1: 10,
        rows: 10,
        contractLoad: false,
        contractData: [],
        dialogContratTitle: '添加合同',
        addVisible: false,
        addData: {},
        supplierId: '',
        selectContract: {
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        // 阶梯
        dialogShow: false,
        waterPriceData: {
          DataTable: [
            {
              startNum: '0',
              endNum: '',
              contractPrice: '',
            },
          ],
        },
        waterRules: {
          startNum: {
            required: true,
            message: '请输入起始数量',
            trigger: 'blur',
          },
          contractPrice: {
            required: true,
            message: '请输入合同价格',
            trigger: 'blur',
          },
        },
        editType: 0,
        checkTableData: [],
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getWorkType() {
        return function (state) {
          switch (state) {
            case 1:
              return '装车';
            case 2:
              return '卸车';
            case 3:
              return '过驳';
            case 4:
              return '转船';
          }
        };
      },
      getSettlement() {
        return function (state) {
          switch (state) {
            case 1:
              return '固定';
            case 2:
              return '比例';
          }
        };
      },
      getContract() {
        return function (state) {
          switch (state) {
            case 1:
              return '固定';
            case 2:
              return '阶梯';
            case 3:
              return '阶梯后返回';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待生效';
            case 1:
              return '生效中';
            case 2:
              return '已失效';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    async mounted() {
      //  await this._portConfigureInforList();
      await this._getCarSerieList();
      await this._supplierPublicSelectPort();
      this.uploadUrl = getImportUrl('/price/supplierPort/batchAddPricePort');
      // const res = await getCarSerieList();
      // if(res.status !== 0) this.$message.error(res.message);
      // else {
      //   this.allCar=res.data;
      //   this.selectBrand = res.data.map(item => {
      //     return {
      //       name: item.brand,
      //       id: item.id,
      //     }
      //   })
      //   res.data.forEach(item =>{
      //     if(item.carModel.length !== 0) this.allModel=[...this.allModel,...item.carModel]
      //   })
      // }
      // const res2 = await customerInfoSelectList();
      // if(res2.status !== 0) this.$message.error(res2.message);
      // else this.nameOption=res2.data;
    },
    filters: {
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    methods: {
      // 合同设置 —— 分页查询
      async contractPageList() {
        const obj = {
          id: this.companyData.name.supplier_id
        };
        this.contractLoad = true;
        let res = await contractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
      },
      //合同设置-重置
      resetContractBtn() {
        for (let key in this.addData) {
          this.addData[key] = '';
        }
      },
      contractBtn() {
        if (!this.companyData.name || this.companyData.name === '') {
          return this.$message.error('请选择港口！');
        }
        // this.selectContract = '';
        // this.contractPageList();
        this.addVisible = true;
      },
      // 合同设置 —— 确认
      contractConfirm() {
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        this.companyData.companyId = this.selectContract.id;
        this.companyData.codeNumber = this.selectContract.codeNumber;
        this.companyData.companyName = this.selectContract.contractName;
        if (this.selectContract.startDate)
          this.companyData.startTime = this.selectContract.startDate;
        if (this.selectContract.endDate) this.companyData.endTime = this.selectContract.endDate;
        this.addVisible = false;
      },
      contractSizeChangeAll(rows) {
        this.rows = rows;
        this.contractPageList();
      },
      contractCurrentChangeOne(page) {
        this.page = page;
        this.contractPageList();
      },
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0)
          return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认启用当前选中港口装卸费吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            let res = await enablePortConfigure({
              id: params.join(','),
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._portConfigureInforList();
          })
          .catch(() => {});
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 下载模板
      downLoad() {
        window.location.href = '/file/供应商港口装卸费批量导入.xlsx';
      },
      /**
       * 导入成功
       * @param data 分页更新数据
       */
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            await this._portConfigureInforList();
          },
        });
      },
      beforeUpload(file) {
        let len = file.name.split('.').length;
        if (file.name.split('.')[len - 1] == 'xls' || file.name.split('.')[len - 1] == 'xlsx') {
          this.uploadData.file = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      async _portConfigureInforList() {
        this.tableLoad = true;
        const res = await portConfigureInforList({
          portName: this.entrustIpt,
          workType: this.typeIpt,
          status: this.stateIpt,
          contractType: this.contractTypeIpt,
          createByName:this.createByName,
          customerCarName: this.customerCarName,
          rows: this.size,
          page: this.page,
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      //适配车型
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item.carModel.length != 0;
        });
        this.modelOption = this.modelOption.map(item => {
          item.carModel.forEach(item => {
            this.modelMap.set(item.id, item.model);
            this.brandMap.set(item.brand_id, item.brand_name);
          });
          return {
            ...item,
            model: item.brand,
          };
        });
        this.modelOption.unshift({
          model: '全选',
          id: '全选',
        });
        // console.log(this.modelOption);
      },
      //港口名称
      async _supplierPublicSelectPort() {
        let res = await supplierPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.nameOption = res.data.map(item => {
          return {
            supplier_name: item.supplier_name,
            id: item.id,
            supplier_id: item.supplier_id
          };
        });
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._portConfigureInforList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._portConfigureInforList();
      },
      // 取消
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.$refs.cascader.value = [];
        this.dialogVisible = false;
      },
      async typeChange() {
        const res = await getTypeInfo(this.companyData.type);
        if (res.status !== 0) return this.$message.error(res.message);
        this.addressOption = res.data.map(item => {
          return {
            id: item.id,
            address: item.address,
          };
        });
      },
      addImgClick() {
        if (!this.companyData.table[this.companyData.table.length - 1].endNum)
          return this.$message.warning('请先输入结束数量！');
        if (isNaN(Number(this.companyData.table[this.companyData.table.length - 1].endNum)))
          return (this.companyData.table[this.companyData.table.length - 1].endNum = '');
        if (
          Number(this.companyData.table[this.companyData.table.length - 1].endNum) <
          Number(this.companyData.table[this.companyData.table.length - 1].startNum)
        ) {
          this.companyData.table[this.companyData.table.length - 1].endNum = '';
          return this.$message.warning('结束数量必须小于开始数量！');
        }
        this.companyData.table.push({
          startNum: Number(this.companyData.table[this.companyData.table.length - 1].endNum) + 1,
        });
      },
      removeClick(index) {
        this.companyData.table.splice(index, 2);
      },
      bjDate(date, date1) {
        var date = new Date(date);
        var date1 = new Date(date1);
        // 减小于0 date<date1
        return date.getTime() - date1.getTime() < 0;
      },
      // 新增/修改 —— 确认
      addClick() {
        this.btnLoad = true;
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (!this.bjDate(this.companyData.start, this.companyData.end))
              return this.$message.warning('结束时间不得小于开始时间！');
            if (
              this.companyData.way == 0 &&
              (this.companyData.price == '' || !this.companyData.price)
            )
              return this.$message.warning('预估价与结算价至少有一个！');
            if (this.companyData.rate < 0) return this.$message.warning('税率不能小于0！');
            if (this.companyData.price < 0) return this.$message.warning('预估价不能小于0！');
            if (this.companyData.price2 < 0) return this.$message.warning('预结算价不能小于0！');
            if (this.companyData.contract !== 1) {
              for (let i = 0; i < this.companyData.table.length; i++) {
                if (this.companyData.table[i].contractPrice === '')
                  return this.$message.warning('请填入阶梯的合同价！');
              }
              if (this.companyData.table[this.companyData.table.length - 1].endNum) {
                if (
                  Number(this.companyData.table[this.companyData.table.length - 1].startNum) >
                  Number(this.companyData.table[this.companyData.table.length - 1].endNum)
                )
                  return this.$message.warning('最后一行起始数量不能高于结束数量！');
              }
            }
            let {
              priceType,
              way,
              name,
              type,
              model,
              rate,
              price,
              price2,
              method,
              method2,
              contract,
              price3,
              table,
            } = this.companyData;
            let status = -1;
            if (way == 0) status = -1;
            if (way == 2) status = 0;
            if ((way == 1 && contract == 1) || (way == 1 && type == 4)) status = 1;
            if (way == 1 && contract == 2 && type != 4) status = 2;
            if (way == 1 && contract == 3 && type != 4) status = 3;
            let obj = {
              portId: name.id,
              portName: name.supplier_name,
              workType: type,
              taxRate: rate,
              estimatePrice: price,
              contractType: status,
              preparePrice: status == 0 ? price2 : '',
              contractFixed: status == 1 ? price3 : '',
              ladderList:
                status == 2 || status == 3
                  ? table.map(item => {
                      return {
                        startNum: item.startNum,
                        endNum: item.endNum,
                        contractPrice: item.contractPrice,
                      };
                    })
                  : [],
              carModelList: model.map(item => {
                return {
                  modelId: item[1],
                  modelName: this.modelMap.get(item[1]),
                  brandId: item[0],
                  brandName: this.brandMap.get(item[0]),
                };
              }),
              startDate: this.companyData.start,
              endDate: this.companyData.end,
              contractId: this.companyData.contractId.id,
              // contractId: this.selectContract.id,
              // contractCode: this.selectContract.codeNumber,
              // contractName: this.selectContract.contractName
            };
            if (this.dialogTitle == '修改港口价格') {
              obj.status = this.companyData.status;
              obj.id = this.companyData.id;
            }
            const res =
              this.dialogTitle != '修改港口价格'
                ? await addPortConfigureInfo(obj)
                : await revisePortConfigure(obj);
            this.btnLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            await this._portConfigureInforList();
          } else {
            return false;
          }
        });
      },
      nameChange(val) {
        this.contractPageList(val)
      },
      carClick() {
        this.carVisible = true;
        this.selectCar = [...this.selectedCar];
        this.brands = [...this.brands2];
        this.models = [...this.models2];
      },
      selectRemove(item) {
        this.selectCar.splice(this.selectCar.indexOf(item), 1);
        if (this.brands.indexOf(item) !== -1) {
          this.brands.splice(this.brands.indexOf(item), 1);
        } else {
          this.models.splice(this.models.indexOf(item), 1);
        }
      },
      brandAdd(item) {
        if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！');
        let arr = [];
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === item.id) {
            arr = this.allCar[i].carModel;
            break;
          }
        }
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.selectCar.length; j++) {
            if (arr[i].id === this.selectCar[j].id) {
              this.selectCar.splice(j, 1);
              j--;
            }
          }
        }
        this.selectCar.push(item);
        this.brands.push(item);
      },
      modelAdd(item) {
        for (let i = 0; i < this.selectCar.length; i++) {
          if (this.selectCar[i].id === item.brandId) {
            return this.$message.warning('上方已选择该品牌的全部车型！');
          } else if (this.selectCar[i].id === item.id)
            return this.$message.warning('已选择该车型！');
        }
        this.selectCar.push(item);
        this.models.push(item);
      },
      carAddClick() {
        this.carVisible = false;
        this.selectedCar = [...this.selectCar];
        this.brands2 = [...this.brands];
        this.models2 = [...this.models];
      },
      carClose() {
        this.carVisible = false;
      },
      brandClick(id) {
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === id) {
            this.selectModel = this.allCar[i].carModel.map(item => {
              return {
                id: item.id,
                name: item.brand_name,
                brandId: item.brand_id,
              };
            });
            break;
          }
        }
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认删除当前港口价格设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await deletePortConfigure(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portConfigureInforList();
          })
          .catch(() => {});
      },
      onClickDeletes() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认删除当前选中的港口价格设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData['id'] + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              let res = await deletePortConfigure(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              await this._portConfigureInforList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      // 补录合同
      recordBtn(row) {
        this.condition.id = row.id;
        this.portName = row.portName;
        this.condition.rate = row.taxRate;
        this.contractPrice = row.contractPrice;
        this.preparePrice = row.preparePrice;
        this.startDate = row.startDate;
        this.endDate = row.endDate;
        this.selectContract = '';
        this.getContractPage();
      },
      //查询
      async getContractPage() {
        let obj = {
          id: this.condition.id,
          portName: this.portName ? this.portName : '',
          contractPrice: this.contractPrice ? this.contractPrice : '',
          preparePrice: this.preparePrice ? this.preparePrice : '',
          page: this.page,
          row: this.row,
        };
        this.contractLoad = true;
        let res = await getContractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) {
          this.$message.error(res.message);
          this.contractVisible = false;
        } else {
          this.contractVisible = true;
          this.contractTableData = res.data.records;
          this.contractTotal = res.data.total;
        }
      },
      async _contractConfirm() {
        if (!this.condition.price || this.condition.price === '') {
          return this.$message.warning('请输入不含税金额！');
        }
        if (!this.condition.taxPrice || this.condition.taxPrice === '') {
          return this.$message.warning('请输入含税金额！');
        }
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        let obj = {
          type: 5,
          rate: this.condition.rate,
          taxPrice: this.condition.taxPrice,
          price: this.condition.price,
          priceInfoId: this.condition.id,
          contractId: this.selectContract.id,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        const res = await addContract(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.contractVisible = false;
      },
      cancel() {
        this.condition.price = '';
        this.condition.taxPrice = '';
        this.contractVisible = false;
      },
      addContractSizeChange(rows) {
        this.row = rows;
        this.getContractPage();
      },
      addContractCurrentChange(page) {
        this.page = page;
        this.getContractPage();
      },
      // 启用
      enableClick(row) {
        this.$confirm('确认启用当前港口装卸费吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await enablePortConfigure({
              id: row.id,
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portConfigureInforList();
          })
          .catch(() => {});
      },
      // 停用
      disableClick(row) {
        this.$confirm('确认停用当前港口装卸费吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await enablePortConfigure({
              id: row.id,
              status: 2,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portConfigureInforList();
          })
          .catch(() => {});
      },
      // 批量停用
      onClickStops() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认停用当前选择的港口装卸费吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              const ids = this.checkTableData.map(item => item.id).join(',');
              let res = await enablePortConfigure({
                id: ids,
                status: 2,
              });
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              await this._portConfigureInforList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择要停用的港口装卸费！',
            type: 'warning',
          });
        }
      },
      // 对象数组排序
      compare(property) {
        return (a, b) => {
          let value1 = a[property];
          let value2 = b[property];
          return value1 - value2;
        };
      },
      // 详情
      async detailClick(id) {
        this.detailDialogVisible = true;
        let res = await portConfigureDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        if (this.detailData.ladderList && this.detailData.ladderList.length > 0) {
          this.detailData.ladderList.sort(this.compare('sort'));
        }
        const res1 = await getContractInfo(id);
        if (res1.status !== 0) return this.$message.error(res1.message);
        this.contractTableList = res1.data;
      },
      // 修改
      async changeClick(row, type) {
        this.editType = type;
        row.changeLoad = true;
        let res = await portConfigureDetail(row.id);
        row.changeLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        let name = '';
        if (res.data.contractCode != null && res.data.contractCode !== '') {
          name = res.data.contractCode + '-' + res.data.contractName;
        } else {
          name = null;
        }
        this.companyData = {
          ...res.data,
          name: {
            supplier_name: res.data.portName,
            id: res.data.portId,
          },
          contractId:{
            id: res.data.contractId,
            name:name
          },
          type: res.data.workType || '',
          model:
            res.data.carModelList.length > 0
              ? res.data.carModelList.map(r => {
                  return [r.brandId, r.modelId];
                })
              : [],
          start: res.data.startDate || '',
          end: res.data.endDate || '',
          rate: res.data.taxRate || '',
          price: res.data.estimatePrice || '',
          price2: res.data.preparePrice || '',
          method: res.data.prepareType || 1,
          method2: res.data.prepareTypePrice,
          contract: res.data.contractType || 1,
          price3: res.data.contractFixed || '',
          way: res.data.contractType == 0 ? 2 : res.data.contractType == -1 ? 0 : 1,
          table:
            res.data && res.data.ladderList && res.data.ladderList.length > 0
              ? res.data.ladderList
              : [{ startNum: 0 }],
        };
        let data = await contractPageList(this.companyData.name.supplier_id);
        if (data.status !== 0) return this.$message.error(data.message);
        this.contractOption = data.data;
        if (this.detailData.table && this.detailData.table.length > 0) {
          this.companyData.table.sort(this.compare('sort'));
        }
        this.dialogVisible = true;
        this.dialogTitle = '修改港口价格';
        this.$nextTick(() => {
          this.$refs.cascader.value = this.companyData.model;
        });
        // this._getCarSerieList();
      },
      searchBtn() {
        this.page = 1;
        this._portConfigureInforList();
      },
      // 新增
      addBtn() {
        this.editType = 0;
        this.dialogVisible = true;
        this.dialogTitle = '添加港口价格';
        this.companyData = {
          way: 0,
          method: 1,
          contract: 1,
          table: [{ startNum: 0 }],
        };
        // this._getCarSerieList()
        // this._supplierPublicSelectPort()
      },
      // 重置
      resetBtn() {
        this.entrustIpt = '';
        this.typeIpt = '';
        this.stateIpt = '';
        this.customerCarName = ''
        this.contractTypeIpt = '';
      },
      //详情-补录合同-删除
      deleteTableClick(row) {
        this.$confirm('确认删除当前合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          let obj = {
            priceInfoId: row.supplementaryContract.priceInfoId,
            contractId: row.supplementaryContract.contractId,
            type: 5,
          };
          const res = await deleteContractInfo(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.detailDialogVisible = false;
        });
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 结算价格设置 —— 分页查询
      async _contractPageList() {
        let obj = {
          ...this.condition,
          page: this.page1,
          rows: this.rows1,
        };
        this.contractLoad = true;
        let res = await contractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractData = res.data;
        this.total1 = res.data.total || 0;
        if (this.companyData.companyId && this.contractData.length > 0) {
          this.contractData.forEach(item => {
            if (item.id == this.companyData.companyId) {
              this.$refs.contractTable.setCurrentRow(item);
            }
          });
        }
      },
      // 结算价格设置 —— 重置
      resetBtn1() {
        for (let key in this.condition) {
          this.condition[key] = '';
        }
      },
      contractSizeChange1(rows) {
        this.rows1 = rows;
        this._contractPageList();
      },
      contractCurrentChange1(page) {
        this.page1 = page;
        this._contractPageList();
      },
      // 结算价格设置 —— 选中合同
      contractChange(val) {
        this.selectContract = val;
      },
      // 结算价格设置 —— 打开弹窗
      priceSetBtn() {
        this.priceSetForm = {
          type: this.companyData.priceType ? parseInt(this.companyData.priceType) : 1,
          price: this.companyData.price ? this.companyData.price : '',
          conType: this.companyData.conType || '',
        };
        this.selectContract = '';
        this._contractPageList();
        this.priceSetVisible = true;
      },
      // 结算价格设置 —— 结算方式改变
      typeChange(type) {
        if (type == 1) {
          this.priceSetForm.conType = 0;
        } else {
          this.priceSetForm.conType = '';
        }
      },
      // 结算价格设置 —— 确认
      priceSetConfirm() {
        if (
          ((this.priceSetForm.type == 1 && this.priceSetForm.conType == 0) ||
            this.priceSetForm.type == 2) &&
          (!this.priceSetForm.price || this.priceSetForm.price == '')
        ) {
          return this.$message.warning('请输入价格！');
        }
        // 阶梯价  结算方式
        if (this.priceSetForm.type == 1 && this.priceSetForm.conType == 1) {
          if (
            this.companyData.priceBasicsLadders &&
            this.companyData.priceBasicsLadders.length <= 0
          ) {
            return this.$message.warning('请设置阶梯价格！');
          }
          this.companyData.priceType = 3;
        } else {
          this.companyData.priceType = this.priceSetForm.type;
        }

        if (
          this.priceSetForm.type == 1 &&
          (!this.selectContract.id || this.selectContract.id == '')
        ) {
          return this.$message.warning('请选择合同！');
        }
        if (this.priceSetForm.type == 0) {
          this.companyData.price = '';
          this.companyData.companyId = '';
          this.companyData.codeNumber = '';
          this.companyData.companyName = '';
          if (this.dataD.showNumber == 1) {
            this.companyData.startTime = '';
            this.companyData.endTime = '';
          }
        } else {
          this.companyData.price = this.priceSetForm.price;

          this.companyData.companyId = this.selectContract.id;
          this.companyData.codeNumber = this.selectContract.codeNumber;
          this.companyData.companyName = this.selectContract.contractName;
          if (this.selectContract.startDate)
            this.companyData.startTime = this.selectContract.startDate;
          if (this.selectContract.endDate) this.companyData.endTime = this.selectContract.endDate;
        }
        this.priceSetVisible = false;
      },

      // 阶梯 -- 打开弹窗
      ladderShow() {
        // this.waterPriceData.DataTable = this.companyData.priceBasicsLadders.length>0?
        //   this.companyData.priceBasicsLadders:
        //   [{startNum:'0', endNum:'', contractPrice:''}];
        this.dialogShow = true;
      },
      // 阶梯 —— 添加
      waterPriceAdd() {
        if (this.waterPriceData.DataTable.length > 0) {
          if (
            this.waterPriceData.DataTable[this.waterPriceData.DataTable.length - 1].endNum == ''
          ) {
            return this.$message.warning('请输入结束数量');
          }
          let len = parseInt(
            this.waterPriceData.DataTable[this.waterPriceData.DataTable.length - 1].endNum,
          );
          this.waterPriceData.DataTable.push({
            startNum: len + 1,
            endNum: '',
            contractPrice: '',
          });
        } else {
          this.waterPriceData.DataTable = [
            {
              startNum: '0',
              endNum: '',
              contractPrice: '',
            },
          ];
        }
      },
      // 阶梯 —— 删除
      waterPriceDeleteTable(index) {
        this.waterPriceData.DataTable.splice(index, 1);
      },
      // 阶梯 —— 结束数量
      waterPriceDataEndNumberChange(index, value) {
        if (!value || value == '') return false;
        if (Number(value) < Number(this.waterPriceData.DataTable[index].startNum)) {
          this.$message.warning('结束数量必须大于起始数量');
          this.waterPriceData.DataTable[index].endNum = '';
        }
      },
      // 阶梯 —— 确认
      waterPriceConfirm() {
        this.$refs.addForm.validate(async valid => {
          if (valid) {
            this.companyData.priceBasicsLadders = [...this.waterPriceData.DataTable];
            this.dialogShow = false;
          }
        });
      },
      // 阶梯 —— 取消
      waterPriceAddClose() {
        this.dialogShow = false;
        this.waterPriceData.DataTable = [];
      },
      getValue(filed, data, isAll) {
        let subData = JSON.parse(JSON.stringify(data));
        isAll ? subData.shift() : '';
        this.companyData[filed] = subData;
      },
      //导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/price/supplierPort/exportExcel?access_token=${token}&portName=${this.entrustIpt}&workType=${this.typeIpt}&status=${this.stateIpt}&contractType=${this.contractTypeIpt}&customerCarName=${this.customerCarName}`;
        window.exportExcelGet('/platform/price/supplierPort/exportExcel', `portName=${this.entrustIpt}&workType=${this.typeIpt}&status=${this.stateIpt}&contractType=${this.contractTypeIpt}&customerCarName=${this.customerCarName}`)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        .tableContainerNav {
          text-align: right;
          color: rgba(51, 136, 255, 1);

          span {
            display: inline-block;
            font-size: 16px;
            text-decoration: underline;

            i {
              font-size: 16px;
              text-decoration: underline;
            }
          }
        }

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            ::v-deep {
              .el-table td,
              .el-table th {
                padding: 0;
              }

              .cell {
                font-size: 10px;
                padding: 0;
              }
            }

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .depart {
      width: 100%;
      padding: 10px 20px 10px 20px;
      max-height: 70vh;
      overflow: auto;

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      .model-item {
        ::v-deep {
          .el-form-item__error {
            top: 80%;
          }
        }
      }

      ::v-deep {
        .el-table td,
        .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 10px;
        }

        .el-cascader.el-cascader--mini {
          margin-bottom: 13px;

          input.el-input__inner {
            height: 32px !important;
          }
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .price-window {
    ::v-deep {
      .el-dialog__body {
        padding: 30px 20px 20px;
        max-height: 70vh;
        overflow-y: auto;
      }

      .cell .el-form-item {
        padding: 0 2px;
      }

      .el-table td,
      .el-table th {
        padding: 3px 0;
      }

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
        text-align: center;
      }

      .el-dialog__title {
        color: #fff;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }
    }

    .navBtn {
      display: inline-block;
      width: calc(100% - 690px);
      text-align: right;
      margin-bottom: 10px;
    }

    .price-set {
      color: #3187ff;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .set-up {
    color: #3187ff;
    position: absolute;
    padding-right: 10px;
    height: 24px;
    line-height: 24px;
    right: 10px;
    top: calc(50% - 12px);
    text-decoration: underline;
    cursor: pointer;
  }

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
